<template>
    <div class="biometrics-edit-modal">

        <!-- edit button -->
        <b-btn size="sm" class="btn-edit btn-icon" variant="default"
               @click.stop="showModal()">
            <shs-icon name="plus"></shs-icon>
        </b-btn>

        <!-- modal -->
        <data-form-modal :modal-id="modalId"
                         :title="$i18n.gt('LABEL_EDIT_BIOMETRICS')"
                         :size="$mq == 'sm' ? 'sm' : 'md'"
                         :horizontal="$mq != 'sm'"
                         :save-button-label="$i18n.gt('LABEL_SAVE')"
                         :field-model="biometricsFields"
                         :field-groups="fieldGroups"
                         :model-instance="editingBiometrics"
                         :on-cancel-handler="cancelModal"
                         :on-submit-handler="save">
        </data-form-modal>

    </div>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
    import Vue from 'vue'
    import BiometricsFields from '@/models/Biometrics'

    /**
     * Button and modal to edit an individual Biometrics record
     */

    export default Vue.extend({
        name: 'BiometricsEditModal',
        props: {
            participantId: Number,
        },
        data() {
            return {
                editingBiometrics: {
                    participant_id: this.participantId,
                    practice_id: this.$store.state.currentUser.practitionerPracticeId
                },
                biometricsFields: BiometricsFields,
                fieldGroups: [
                    ['tchol', 'ldl_c', 'hdl_c', 'trig', 'fasting_bg', 'a1c', 'comment']
                ],
            }
        },
        computed: {
            modalId() {
                return `biometricsModal`
            }
        },
        methods: {
            showModal() {
                this.$bvModal.show(this.modalId)
            },
            cancelModal() {
                this.$bvModal.hide(this.modalId)
            },
            async save() {
                await this.$api.createItem(this, 'biometrics', this.editingBiometrics, true)
                this.refresh()
            },
            refresh() {
                this.$store.dispatch('getPatientParticipant',
                    {
                        participantId: this.editingBiometrics.participant_id,
                        force: true
                    })
            }
        },
    })
</script>
